import { useEffect, useState } from "react";

export function Announcement({ announcementText }: { announcementText: string }) {
  const [announcement, setAnnouncement] = useState("");

  useEffect(() => {
    // Reset first to trigger screen reader
    setAnnouncement("");
    const timeout = setTimeout(() => {
      setAnnouncement(announcementText);
    }, 100); // slight delay to ensure screen reader notices the change

    return () => clearTimeout(timeout);
  }, [announcementText]);
  return (
    <div
      tabIndex={ -1 }
      id={ `announcement-${announcementText}` }
      aria-live="polite"
      aria-atomic="true"
      style={ {
        position: "absolute",       // Remove from normal flow
        width: "1px",               // Tiny size
        height: "1px",
        padding: 0,
        margin: "-1px",             // Push out of visible area
        overflow: "hidden",         // Hide any overflow
        clip: "rect(0 0 0 0)",      // Clip completely
        clipPath: "inset(50%)",     // Modern browsers
        whiteSpace: "nowrap",       // Prevent wrapping
        border: 0 } }
    >
      { announcement }
    </div>
  );
}
